import { State } from './types/State';

const reducer = (referenceData: State = {}) => referenceData;

export default reducer;
